export default {
  first_name: '',
  last_name: '',
  username: '',
  password: null,
  confirm_password: null,
  display_name: '',
  email: '',
  title: '',
  phone: '',
  active: true,
  show_on_app: false,
  roles: [],
};
